import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils/cn';
import { FLAG_LABELS } from './constants.js';
import type { FlagDiffEntry } from './use-flag-form.js';

interface Props {
  open: boolean;
  diff: FlagDiffEntry[];
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PreSaveSummary({ open, diff, loading, onConfirm, onCancel }: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && !loading && onCancel()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Confirmar cambios</DialogTitle>
        </DialogHeader>
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-wide text-[var(--color-ink-muted)]">
              <tr>
                <th className="pb-2 text-left font-medium">Flag</th>
                <th className="pb-2 text-left font-medium">Antes</th>
                <th className="pb-2 text-left font-medium">Despues</th>
              </tr>
            </thead>
            <tbody>
              {diff.map((entry) => {
                const isDisabling = entry.before && !entry.after;
                return (
                  <tr
                    key={entry.key}
                    data-testid={`diff-row-${entry.key}`}
                    data-disabling={isDisabling ? 'true' : undefined}
                    className={cn(
                      'border-t border-[var(--color-hairline)]',
                      isDisabling &&
                        'border-l-4 border-l-[var(--color-warning,theme(colors.amber.500))]',
                    )}
                  >
                    <td className="py-2 pr-2">{FLAG_LABELS[entry.key]}</td>
                    <td className="py-2 pr-2 text-[var(--color-ink-muted)]">
                      {entry.before ? 'activo' : 'inactivo'}
                    </td>
                    <td className="py-2">{entry.after ? 'activo' : 'inactivo'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>
            Cancelar
          </Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirmar y guardar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
